import { render, staticRenderFns } from "./roi-area.vue?vue&type=template&id=334a965b&scoped=true&"
import script from "./roi-area.vue?vue&type=script&lang=ts&"
export * from "./roi-area.vue?vue&type=script&lang=ts&"
import style0 from "./roi-area.vue?vue&type=style&index=0&id=334a965b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334a965b",
  null
  
)

export default component.exports